<template>
  <div class="shockData">
    <div class="chart-list">
      <div v-for="(data, i) in filterChartlist" :key="i">
        <div :id="`roots_pump_ms_id${i + data.id}`" class="chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  linesRelationsChart
} from "@/minix.js";
import { getRawTimeseries } from "@/service/index";
import moment from "moment";
// import * as echarts from "echarts";
import _ from "lodash";
import qs from "qs";
import debounce from "lodash/debounce";
export default {
  name: "shockData",
  props: ["equip_data", "chartlist", "chartIndex"],
  data() {
    return {
      roots_pump_ms_id: `roots_pump_ms_${+new Date()}`,
      roots_pump_ma_id: `roots_pump_ma_${+new Date()}`,
      roots_pump_mc_id: `roots_pump_mc_${+new Date()}`,
      roots_pump_id: `roots_pump_${+new Date()}`,
      xAxisData: [],
      timer1: null,
      timer2: null,
      timer3: null,
      timer4: null,
      // 组装charts需要参数
      echartsData: [],
    };
  },
  computed: {
    name() {
      return this.$t("Unit Real-time Operation Data");
    },
    filterChartlist() {
      return this.chartlist.filter((item) => {
        return this.chartIndex.includes(item.id);
      });
    },
  },
  watch: {
    // "$i18n.locale": {
    //   handler() {
    //     // this.initChart();
    //   },
    //   deep: true,
    // },
    filterChartlist: {
      handler(newVal) {
        // this.initchartdata();
        if (newVal.length>0) {
          this.initECharts(newVal);
        }
      },
      deep: true,
    },
    chartIndex: {
      handler:debounce(function (newVal){ //防抖节流
          if (newVal.length>0) {
            this.initchartdata();
            this.$nextTick(() => {
              this.initECharts(this.filterChartlist);
            });
          }
        },300)
        ,deep: true,
    },
    // equip_data: {
    //   handler(newVal) {
    //     if (newVal) {
    //       this.initchartdata();
    //     }
    //   },
    //   deep: true,
    // },
  },
  mounted() {
      this.$nextTick(() => {
        this.initchartdata();
      });
  },

  updated() {},
  unmounted() {
    clearInterval(this.timer1);
    clearInterval(this.timer2);
    clearInterval(this.timer3);
    clearInterval(this.timer4);
  },
  methods: {
    async initchartdata() {
      /* 组装初始echarts数据 */
      let list = _.cloneDeep(this.filterChartlist);
      // 获取历史数据赋值
      var column = [];
      list.forEach((item) => {
        column.push(item.key);
        item.data = {
          date: [], //x轴数据
          data1: [], //y轴数据
        };
      });
      this.echartsData = [];
      let paramsdata = {
        start: "10m",
        end: "0m",
        limit: 14,
        // prePageNum: this.prePageNum,
        column,
      };
      if (column.length > 0) {
        let params = qs.stringify(paramsdata, { arrayFormat: "repeat" });
        await getRawTimeseries(this.equip_data.id, params).then((res) => {
          if (res.payload) {
            list.forEach((item, i) => {
              res.payload.length &&
                res.payload.map((measure) => {
                  if (measure[item.key]||measure[item.key]===0) {
                    item.data.date.push(moment(measure.ts).format("HH:mm:ss"));
                    item.data.data1.push(Number(measure[item.key].toFixed(3)));
                  }
                });
              if (document.getElementById(`roots_pump_ms_id${i + item.id}`)) {
                this.echartsData.push({
                  chartDom: document.getElementById(
                    `roots_pump_ms_id${i + item.id}`
                  ),
                  name: `${item.name}（${item.unit}）`,
                  legend: `${item.name}（${item.unit}）`,
                  data: item.data,
                  info:item,
                  // data:{
                  //   date:[],//x轴数据
                  //   data1:[],//y轴数据
                  // }
                });
              }
              if (item.v && this.echartsData[i] && this.echartsData[i].data) {
                if (this.echartsData[i].data.data1.length < 15) {
                  this.echartsData[i].data.data1.push(item.v);
                  this.echartsData[i].data.date.push(
                    moment()
                      .add(-i - 1, "second")
                      .format("HH:mm:ss")
                  );
                } else {
                  this.echartsData[i].data.data1.shift(1);
                  this.echartsData[i].data.date.shift(1);
                  this.echartsData[i].data.data1.push(item.v);
                  this.echartsData[i].data.date.push(
                    moment()
                      .add(-i - 1, "second")
                      .format("HH:mm:ss")
                  );
                }
              }
            });
            this.$nextTick(() => {
              this.echartsData.forEach((item) => {
                linesRelationsChart(item);
              });
            });
          }
        });
      }
    },
    initECharts(newVal) {
      newVal.length &&
        newVal.map((item, i) => {
          if ((item.v||item.v===0) && this.echartsData[i] && this.echartsData[i].data) {
            if (this.echartsData[i].data.data1.length < 15) {
              this.echartsData[i].data.data1.push(Number(item.v.toFixed(2)));
              this.echartsData[i].data.date.push(
                moment()
                  .add(-i - 1, "second")
                  .format("HH:mm:ss")
              );
            } else {
              this.echartsData[i].data.data1.shift(1);
              this.echartsData[i].data.date.shift(1);
              this.echartsData[i].data.data1.push(item.v);
              this.echartsData[i].data.date.push(
                moment()
                  .add(-i - 1, "second")
                  .format("HH:mm:ss")
              );
            }
          }
        });
      this.echartsData.forEach((item) => {
        this.$nextTick(() => {
          linesRelationsChart(item);
        });
      });
    },
    moment,
  },
  components: {},
};
</script>

<style scoped lang="scss">
.shockData {
  height: 100%;
  display: flex;
  flex-flow: column;
  .chart-list {
    margin-top: 15px;
    height: calc(100% - 30px);
    display: flex;
    flex-flow: column;
    overflow: hidden;
    overflow-y: scroll;
    .chart {
      width: 360px;
      height: 238px;
      border-bottom: 1px dashed #ccc;
      margin-bottom: 10px;
      &:nth-last-of-type(1) {
        border-bottom: 0;
        margin-bottom: 0;
      }
    }
  }
}
.chart-list::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.chart-list {
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}
</style>
